<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal';
import type { StyleValue } from 'vue-final-modal';
import { type RendererElement, type TransitionProps } from 'vue';
import type { Options } from 'focus-trap';
// Keep it all for now, some will be fixed and not available for customizations, of course

interface IProps {
    displayDirective?: 'if' | 'show' | 'visible';
    hideOverlay?: boolean;
    overlayTransition?:
        | (
              | (string & {})
              | 'vfm-fade'
              | 'vfm-slide-down'
              | 'vfm-slide-up'
              | 'vfm-slide-right'
              | 'vfm-slide-left'
          )
        | TransitionProps;
    contentTransition?:
        | (
              | (string & {})
              | 'vfm-fade'
              | 'vfm-slide-down'
              | 'vfm-slide-up'
              | 'vfm-slide-right'
              | 'vfm-slide-left'
          )
        | TransitionProps;
    overlayClass?: any;
    contentClass?: any;
    overlayStyle?: StyleValue;
    contentStyle?: StyleValue;
    background?: 'interactive' | 'non-interactive';
    focusTrap?: false | Options;
    reserveScrollBarGap?: boolean;
    zIndexFn?: (context: { index: number }) => number | undefined;
    swipeToClose?: 'none' | 'up' | 'right' | 'down' | 'left';
    threshold?: number;
    showSwipeBanner?: boolean;
    preventNavigationGestures?: boolean;
    teleportTo?: string | false | RendererElement;
    onBeforeOpen?: () => any;
    onOpened?: () => any;
    onBeforeClose?: () => any;
    onClosed?: () => any;
    onClickOutside?: () => any;
    permanent?: boolean;
    backdropFactor?: number;
    zIndex?: number;
}

const props = defineProps<IProps>();
defineEmits<{
    beforeOpen: [];
    opened: [];
    beforeClose: [];
    closed: [];
    clickOutside: [];
}>();
const backdrop = computed(() => `blur(${props.backdropFactor || 10}px)`);
function zIndexFnComputed(index: number) {
    if (props.zIndexFn) {
        return props.zIndexFn({ index });
    }
    if (props.zIndex) {
        return props.zIndex;
    }
    return index * 100 + 100000;
}
</script>

<template>
    <VueFinalModal
        v-bind="props"
        :style="{ '--backdrop': backdrop }"
        :z-index-fn="({ index }) => zIndexFnComputed(index)"
        lock-scroll
        :esc-to-close="!permanent"
        :click-to-close="!permanent"
    >
        <slot />
    </VueFinalModal>
</template>
<style lang="scss">
.vfm {
    direction: ltr;
    z-index: var(--z-index);
    display: flex;
    align-items: center;
    justify-content: center;
}
.vfm__overlay {
    background-color: rgba(11, 95, 179, 0.3);
    backdrop-filter: var(--backdrop);
}
.vfm__content {
    background-color: white;
    border-radius: 12px;
    contain: layout;
    &:has(.mobile-page) {
        @include mobile-only {
            border-radius: 0 !important;
            height: 100%;
        }
    }
}
</style>
